var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCerti2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 65,
    viewBox: "0 0 73 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1449_20979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3838 29.5631C28.362 29.5631 32.1773 28.1584 34.9904 25.6579C37.8034 23.1574 39.3838 19.766 39.3838 16.2298C39.3838 12.6936 37.8034 9.30221 34.9904 6.80173C32.1773 4.30124 28.362 2.89648 24.3838 2.89648C20.4055 2.89648 16.5902 4.30124 13.7772 6.80173C10.9641 9.30221 9.38379 12.6936 9.38379 16.2298C9.38379 19.766 10.9641 23.1574 13.7772 25.6579C16.5902 28.1584 20.4055 29.5631 24.3838 29.5631ZM24.3838 29.5631C30.4228 29.5631 35.6998 31.5898 39.4528 34.9578C41.6783 36.9628 43.343 39.4043 44.3128 42.0858M24.3838 29.5631C12.3838 29.5631 3.38379 37.5631 3.38379 48.2298V61.5631H33.3838M36.3838 50.4271L48.9538 58.8965L69.3838 34.8965",
    stroke: "#FF9900",
    strokeWidth: 6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1449_20979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 64,
    fill: "white",
    transform: "translate(0.383789 0.230469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerti2);
export default __webpack_public_path__ + "static/media/certi2.9f39d1cd7fa87d5b495e7526f595b4de.svg";
export { ForwardRef as ReactComponent };